import { put } from 'redux-saga/effects'
import { Game } from '../../Core'

import AnyTestingButton from './AnyTestingButton'
import UIButton from './UIButton'

/**
 * [loadComponents description]
 * @return {Generator} [description]
 */
export function* loadComponents() {
  const components = {
    AnyTestingButton,
    UIButton,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 *  UI module init.
 */
function* init() {
  yield loadComponents()
}

/**
 * [sagas description]
 * @return {Generator} [description]
 */
export function* sagas() {
  yield init()
}
